module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil.703622ce.mp3";